import ChangeExamContainer from './ChangeExamContainer';

export default { ChangeExamContainer };
